<!-- Signed out: one plain door into the one sign-in screen. No page asks for a number in its own body. -->
@if (!signedIn) {<button
  type="button"
  class="lm-acct__signin"
 
  (click)="signIn()"
>
  <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
       stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
    <circle cx="12" cy="8.5" r="3.5"></circle>
    <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6"></path>
  </svg>
  Sign in
</button>}

<!-- Signed in: who you are, and everything that belongs to the account, in one place. -->
@if (signedIn) {<div class="lm-acct">
  <button
    type="button"
    class="lm-acct__btn"
    (click)="toggle()"
    [attr.aria-expanded]="open"
    aria-haspopup="menu"
    [attr.aria-label]="'Account: ' + label"
  >
    <span class="lm-acct__avatar" aria-hidden="true">
      @if (initials) {{{ initials }}} @else {
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9"
             stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="8.5" r="3.5"></circle>
          <path d="M5 20c0-3.6 3.1-6 7-6s7 2.4 7 6"></path>
        </svg>
      }&ngsp;
      
    </span>
    <span class="lm-acct__name lm-wrap">{{ label }}</span>
    <span class="lm-acct__caret" [class.is-open]="open" aria-hidden="true">
      <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4"
           stroke-linecap="round" stroke-linejoin="round"><path d="M5 9l7 7 7-7"></path></svg>
    </span>
  </button>

  @if (open) {<div class="lm-acct__menu" role="menu">
    <p class="lm-acct__who">
      <span class="lm-acct__whoName lm-wrap">{{ label }}</span>
      @if (summary?.membershipNo) {<span class="lm-acct__whoNo lm-money">{{ summary?.membershipNo }}</span>}
    </p>
    <a class="lm-acct__item" role="menuitem" routerLink="/my-membership">My membership</a>
    <a class="lm-acct__item" role="menuitem" routerLink="/profile">My profile</a>
    <a class="lm-acct__item" role="menuitem" routerLink="/refer">Refer &amp; Earn</a>
    <button type="button" class="lm-acct__item lm-acct__item--out" role="menuitem" (click)="signOut()">Sign out</button>
  </div>}
</div>}
